import React from 'react';
import classNames from 'classnames';

export interface CardMediaProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'inset' | 'exdent';
  setAspect?: '9x16' | '1x1' | '4x3' | '16x9' | '2x1';
}

/**
 * The Card Media based on [The USWDS card component](https://designsystem.digital.gov/components/card/)
 *
 */
const CardMedia = ({ children, className, id, variant, setAspect }: CardMediaProps): JSX.Element => {
  const setAspectClassName = setAspect ? `usa-card__media--set-aspect.add-aspect-${setAspect}` : '';
  const cardMediaClasses = classNames(setAspectClassName, {
    'usa-card__media': true,
    'usa-card__media--inset': variant === 'inset',
    'usa-card__media--exdent': variant === 'exdent',
  });

  const cardImageClasses = classNames(className, 'usa-card__img');

  return (
    <div id={id} className={cardMediaClasses}>
      <div className={cardImageClasses}>{children}</div>
    </div>
  );
};

export default CardMedia;
